<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
import bookingDetailsMixin from '@/mixins/bookingDetailsMixin'
import CommentType from '@/shared/constants/comments/CommentType'
import CommentList from '../comments/comment-list.vue'

export default {
  name: 'BookingDetailsTabHistory',
  components: { CommentList },
  mixins: [baseMixin, bookingDetailsMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isABookingRequest() {
      return this.isBookingRequest(this.booking.status)
    },
    compRequestComments() {
      // TODO: If we need to factor in comments left on the approval or different statuses
      // this will need to be updated
      switch (this.booking.status) {
        case 'pendingApproval':
          return [
            new CommentModel({
              id: 1,
              commentText: this.$t(
                'booking.details.comments.pendingApprovalText',
                [this.booking.createdBy.name]
              ),
              addedBy: this.booking.createdBy.name,
              type: CommentType.BookingApprovalCreated,
              dateCreated: this.booking.createdOnUtc,
            }),
          ]
        default:
          return []
      }
    },
    compBookingHistoryComments() {
      return this.isABookingRequest
        ? this.compRequestComments
        : this.booking.comments.map((comment) => new CommentModel(comment))
    },
  },
}
</script>

<template>
  <CommentList :comments="compBookingHistoryComments" />
</template>
